import React, { useState, useEffect } from "react";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  BlockDes,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
} from "../../components/Component";

import { useSelector } from "react-redux";
import { Col, Flex, Row, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import TenderSummaryWidget from "../Dashboard/TenderSummaryWidget";
import TenderRiskIndicators from "../Dashboard/TenderRiskIndicators";
import MarketEngagementTrend from "../Dashboard/MarketEngagementTrend";
import TopAwardeesTable from "../Dashboard/TopAwardeesTable";
import TopEvaluatorsProductivity from "../Dashboard/TopEvaluatorsProductivity";
import LiveTendersLowResponses from "../Dashboard/LiveTendersLowResponses";
import EvaluationCompletionByTender from "../Dashboard/EvaluationCompletionByTender";
const TenderManagementDashboard = () => {
  const { data: currentUser } = useSelector((state: any) => state.currentUser);

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility } = currentUser;
      if (siteAccessibility) {
        const allSites: any = [];
        const _siteOptions: any = [];
        siteAccessibility?.forEach((item: any) => {
          allSites.push(item.siteID);
          _siteOptions.push({ label: item.siteName, value: item.siteID });
        });
      }
    }
  }, [currentUser]);

  return (
    <React.Fragment>
      <Head title="projects dashboard" />
      <Content>
        {/* <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Tender Management Dashboard</BlockTitle>
              <BlockDes className="text-soft">
                <p>Welcome to Procurex.</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent></BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        {/* {loadingCount > 0 ? ( */}
        <>
          <Row gutter={[16, 16]} align="stretch">
            <Col span={9}>
              <TenderSummaryWidget />
            </Col>

            <Col span={15}>
              <TenderRiskIndicators />
            </Col>
          </Row>

          <Row gutter={[16, 16]} align="stretch" style={{ marginTop: "20px" }}>
            <Col span={24}>
              <MarketEngagementTrend></MarketEngagementTrend>
            </Col>
          </Row>
          <Row gutter={[16, 16]} align="stretch" style={{ marginTop: "20px" }}>
            <Col span={12}>
              <TopAwardeesTable></TopAwardeesTable>
            </Col>
            <Col span={12}>
              <TopEvaluatorsProductivity></TopEvaluatorsProductivity>
            </Col>
          </Row>
          <Row gutter={[16, 16]} align="stretch" style={{ marginTop: "20px" }}>
            <Col span={24}>
              <LiveTendersLowResponses></LiveTendersLowResponses>
            </Col>
          </Row>
          <Row gutter={[16, 16]} align="stretch" style={{ marginTop: "20px" }}>
            <Col span={24}>
              <EvaluationCompletionByTender></EvaluationCompletionByTender>
            </Col>
          </Row>
        </>
      </Content>
    </React.Fragment>
  );
};

export default TenderManagementDashboard;
